import { useCallback } from "react"
import { useAxiosInstances } from "../axios-instance"
import { ICompany } from "../../application/models/ICompany"

export const useCompanyApi = () => {
  const { axiosAuthInstance } = useAxiosInstances()

  const findCompanyById = useCallback((data: {
    companyId: string
  }): Promise<ICompany> => {


    return axiosAuthInstance.get(`/routes/company/${data.companyId}`)
      .then((res) => {
        const result = res.data.result.company as ICompany
        if (result) {
          return result
        } else {
          throw new Error('Company not found')
        }
      })
  }, [axiosAuthInstance])

  const findCompaniesBySearchTermApi = useCallback((data: {
    userId: string
    searchTerm?: string
    page?: number
  }): Promise<{
    companies: {
      companyId: string
      cnpj: string
      razaoSocial: string
    }[]
  }> => {
    return axiosAuthInstance.get('/routes/company/companies', {
      params: {
        ...data
      }
    }).then((res) => {
      const result = res.data.result

      if (result) {
        return result
      } else {
        throw new Error('Erro ao buscar empresas')
      }
    })
  }, [axiosAuthInstance])

  return {
    findCompanyById,
    findCompaniesBySearchTermApi
  }
}